export default (
  state = {
    combineAndSaveOffers: [],
    purchased_items: [],
  },
  action,
) => {
  switch (action.type) {
    case 'FETCHING_OFFERS':
      return {
        ...state,
        fetchingOffers: true,
      };
    case 'INITIAL_OFFERS_DATA':
      return {
        ...state,
        fetchingOffers: false,
        combineAndSaveOffers: action.payload,
      };
    case 'FETCHING_OFFERS_ERROR':
      return {
        ...state,
        fetchingOffers: false,
        offersError: action.error,
      };
    case 'ADDING_OFFER_TO_CART':
      return {
        ...state,
        addingOfferToCart: true,
      };
    case 'OFFER_ADDED_TO_CART': {
      const newState = {
        ...state,
        addingOfferToCart: false,
      };
      newState.purchased_items = [
        ...state.purchased_items,
        { id: action.id, size: action.name, price: action.price },
      ];
      return newState;
    }
    default:
      return state;
  }
};
